// 季節の飾りは、リロードすると読み込み時と turbo:load で 2 回描くうえ、画面の大きさが変わっても描き直す。
// 飾りが別の位置に描き直されないよう、同じページのあいだは同じ乱数を順に使う。
// 描くたびに pageRandom() を呼び、返された random(min, max) を使う
export const createPageRandom = () => {
  let page = { url: null, values: [] };
  return () => {
    if (page.url !== location.href) {
      page = { url: location.href, values: [] };
    }
    const { values } = page;
    let i = 0;
    return (min, max) => {
      if (i === values.length) values.push(Math.random());
      return min + values[i++] * (max - min);
    };
  };
};
